import 'assets/scss/detail2.scss'
import { boolStr } from 'helpers/utils'
import MoveInstructionAudio from './audio'
import { useParams } from 'react-router-dom'
import { formatDateTime } from 'common/usual'
import React, { useState, useEffect, useMemo } from 'react'
import { MoveInstructionTextDetailPromise } from 'api/MoveWorkout'
import { Card, Grid, Typography, Paper } from '@material-ui/core'

const MoveInstructionTextDetail = (props) => {
  const { id } = useParams()
  const [record, setRecord] = useState({})

  useEffect(() => {
    if (id) {
      MoveInstructionTextDetailPromise(id)
        .then(resp => {
          setRecord(resp)
        })
    }
  }, [id])

  const basicInfoData = useMemo(() => {
    if (!record) return [];
    
    return [
      { label: 'ID', value: record.id },
      { label: 'Active', value: boolStr(record.active) },
      { label: 'Created At', value: formatDateTime(record.created_at) },
      { label: 'Updated At', value: formatDateTime(record.updated_at) }
    ];
  }, [record]);

  const resourceData = useMemo(() => {
    if (!record || !record.move_resource) return [];
    
    return [
      { label: 'Resource ID', value: record.move_resource_id },
      { label: 'Resource Name', value: record.move_resource.name },
      { label: 'Trainer ID', value: record.move_resource.trainer_id },
    ];
  }, [record]);

  const renderDetailCard = (title, items) => {
    return (
      <Card className="detail-card">
        <div className="detail-card-title">
          {title}
        </div>
        <div className="detail-card-content">
          {items.map((item, index) => (
            <div key={index} className="detail-card-row">
              <Typography variant="body1" className="detail-card-row-label">{item.label}</Typography>
              <Typography variant="body1" className="detail-card-row-value">{item.value}</Typography>
            </div>
          ))}
        </div>
      </Card>
    );
  };

  return (
    <div className="detail-page">
      <div className="root" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h2>Move Instruction Text Details</h2>
      </div>

      <div className="root">
        <Grid container spacing={4}>
          <Grid item xs={6}>
            {renderDetailCard('SETUP', basicInfoData)}
          </Grid>

          <Grid item xs={6}>
            {renderDetailCard('MOVE RESOURCE', resourceData)}
          </Grid>

          <Grid item xs={12}>
            <Card className="detail-card">
              <div className="detail-card-title">
                <Typography variant="subtitle1" className="detail-card-label">INSTRUCTION TEXT</Typography>
              </div>
              <Paper className="detail-card-content" variant="outlined" style={{ padding: 16 }}>
                {record.text}
              </Paper>
            </Card>
          </Grid>

          {record.move_instruction_audios && record.move_instruction_audios.length > 0 && (
            <Grid item xs={12}>
              <Card className="detail-card">
                <div className="detail-card-title">
                  <Typography variant="subtitle1" className="detail-card-label">AUDIO</Typography>
                </div>
                <div>
                  <MoveInstructionAudio data={record.move_instruction_audios} />
                </div>
              </Card>
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  )
}

export default MoveInstructionTextDetail 